module.exports = __webpack_public_path__ + "img/user.2753a44e.svg";